import { i18n } from 'src/i18n';
import dataStudioEnumerators from 'src/modules/dataStudio/dataStudioEnumerators';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';

export default [
  {
    name: 'name',
    label: i18n('entities.dataStudio.fields.name'),
    schema: schemas.string(
      i18n('entities.dataStudio.fields.name'),
      {},
    ),
  },
  {
    name: 'link',
    label: i18n('entities.dataStudio.fields.link'),
    schema: schemas.string(
      i18n('entities.dataStudio.fields.link'),
      {},
    ),
  },
  {
    name: 'permissionRoles',
    label: i18n(
      'entities.dataStudio.fields.permissionRoles',
    ),
    schema: schemas.enumerator(
      i18n('entities.dataStudio.fields.permissionRoles'),
      {
        options: dataStudioEnumerators.permissionRoles,
      },
    ),
  },
];
